<template>
  <BaseSelect 
    styled 
    arrow 
    checkbox 
    class="select-header" 
    :model-value="switchedCountry"
    :options="options" 
    @change="switchCountry">
  </BaseSelect>
</template>
<script setup lang="ts">
import { computed } from "vue";
import BaseSelect from "~/components/input/BaseSelect.vue";
import { storeToRefs } from "pinia";
import { useCountriesStore } from "~/stores/countries";

const { setLocale } = useI18n();
const { currentCountry } = storeToRefs(useCountriesStore());

const switchedCountry = computed(() => {
  return currentCountry.value.code === "cy" ? { id: "CY", value: "CY" } : { id: "LT", value: "LT" };
});

const switchCountry = (value) => {
  const newLocale = value.id === "CY" ? "en-cy" : "en-lt";
  setLocale(newLocale);
};

const options = [
  {
    value: "Cyprus",
    id: "CY",
    code: "CY"
  },
  {
    value: "Lithuania",
    id: "LT",
    code: "LT"
  },
];
</script>
